const colors = ['blue', 'green', 'red'];

export default currentNumberOfBabies =>
  colors[currentNumberOfBabies % colors.length];
